import { useState, useRef } from "react"
import { cn } from "@/lib/utils"

interface AnimatedCardProps {
  children: React.ReactNode
  className?: string
  hoverScale?: boolean
  glowEffect?: boolean
  tiltEffect?: boolean
}

export function AnimatedCard({ 
  children, 
  className, 
  hoverScale = true, 
  glowEffect = false,
  tiltEffect = false 
}: AnimatedCardProps) {
  const [isHovered, setIsHovered] = useState(false)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })
  const cardRef = useRef<HTMLDivElement>(null)

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!tiltEffect || !cardRef.current) return

    const rect = cardRef.current.getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const centerY = rect.top + rect.height / 2
    
    const mouseX = e.clientX - centerX
    const mouseY = e.clientY - centerY
    
    setMousePosition({ x: mouseX * 0.1, y: mouseY * 0.1 })
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
    setMousePosition({ x: 0, y: 0 })
  }

  return (
    <div
      ref={cardRef}
      className={cn(
        "relative transition-all duration-300 ease-out",
        hoverScale && "hover:scale-[1.02]",
        className
      )}
      style={
        tiltEffect
          ? {
              transform: `perspective(1000px) rotateX(${-mousePosition.y}deg) rotateY(${mousePosition.x}deg)`,
            }
          : undefined
      }
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      {glowEffect && isHovered && (
        <div className="absolute -inset-1 bg-gradient-to-r from-primary/20 via-accent/20 to-primary/20 rounded-lg blur opacity-75 animate-pulse" />
      )}
      
      <div className="relative">
        {children}
      </div>
    </div>
  )
}